<template>
  <ValidationObserver ref="gender">
    <div>
      <h2 class="mb-5">
        Which gender do you identify as?
      </h2>
    </div>
    <ValidationProvider v-slot="{ errors }" name="gender" rules="required">
      <RadioButton
        v-model="gender"
        @select="val => (gender = val)"
        :options="genderOptions"
        :errorMessages="showValidationErrors ? errors : ''"
        mixed
        :selectedValue="gender"
      />
    </ValidationProvider>
    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import RadioButton from "@/components/common/RadioButton";
import {
  includePreferNotSayOption,
  getFormattedValue
} from "@/views/profile/QuestionsAndAnswers/steps/Diversity/utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const GENDER_OPTIONS = [
  {
    label: "Male",
    value: "male"
  },
  {
    label: "Female",
    value: "female"
  },
  {
    label: "Other...",
    value: "other"
  }
];

export default {
  name: "Gender",
  components: {
    PrimaryButton,
    RadioButton,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    isLoading: Boolean,
    userData: Object
  },
  created() {
    this.gender = this.userData.gender;
  },
  data() {
    return {
      showValidationErrors: false,
      gender: null,
      genderOptions: includePreferNotSayOption(GENDER_OPTIONS)
    };
  },
  methods: {
    async nextStep() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.gender.validate();
      if (isValid) {
        this.$emit("nextStep", {
          data: { gender: getFormattedValue(this.gender) },
          dataType: "mainDetails"
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
